import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=4cc40db9&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=4cc40db9&prod&scoped=true&lang=css"
import style1 from "./Formulario.vue?vue&type=style&index=1&id=4cc40db9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc40db9",
  null
  
)

export default component.exports